import React from "react";
import * as ReactDOM from "react-dom";
import { EnquiryV3 } from "./EnquiryV3";

(window as any).RenderEnquiry = function (props) {
    document.body.classList.add('overflow-hidden')
    ReactDOM.render(<EnquiryV3 {...props} />, document.getElementById("enquiry-wrapper"));
};
